import { getRecentRecords, type RecentRecord } from '../utils/recent-records.js';

export async function getRecentRecordsWithApacHydration(): Promise<RecentRecord[]> {
	return getRecentRecords();
}
